import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';

import { load, connectMoreNews } from 'modules/Common/reducers/morenews';
import { loadMediaForArticles } from 'modules/Common/reducers/media';

import NewsSection from 'modules/Common/components/NewsSection';

const PATH = '/columnists';

@layoutAsyncConnect(
  "HomeColumnists",
  [{
    dispatch: () => load(PATH, 3),
    state: connectMoreNews,
    then: ({dispatch, state, result: {articles}}) => loadMediaForArticles(state, dispatch, articles)
  }]
)
export default class HomeColumnists extends Component {
  static propTypes = {
    news: PropTypes.object
  };

  render() {
    const {
      news: {
        [PATH]: {
          articles: newsItems = []
        } = {}
      } = {}
    } = this.props;

    const componentData = {
      showHeading: true,
      showCategory: true,
      sectionLabel: "Columnists",
      expandedHeading: false,
      sectionLink: PATH,
      additionalNewsLinks: [
        {text: "All Columnists", href: PATH}
      ],
      newsItems: newsItems.slice(0, 3)
    };

    return (
      <NewsSection {...componentData} />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Home/containers/HomeColumnists.js